<template>
  <div>
    <v-flex xs12 class="pl-0 pr-0 py-1">
      <v-row class="pr-5">
        <v-flex xs12 class="primary br-10 mb-4" v-if="node.type == 'group'">
          <h4 class="white--text">Group Structure</h4>
        </v-flex>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          v-if="node.type !== 'parent'"
          class="text-capitalize px-0 pt-2"
          style="max-width: 100px;"
        >
          <!-- <span v-if="node.type === 'subgroup'">
            {{ node.type }} {{ node.index + 1 }}
          </span> -->
          <span class="fs-15">
            {{ node.type === 'bo' ? 'BO' : node.type }}
          </span>
        </v-col>
        <!-- </v-row>
        <v-row> -->
        <v-col cols="6" class="py-0 px-1 pl-0" v-if="node.type === 'parent'">
          <!-- <v-text-field
            single-line
            outlined
            dense
            placeholder="Division"
            v-model="node.name"
            required
          ></v-text-field> -->
          <v-autocomplete
            id="division"
            single-line
            outlined
            dense
            placeholder="Division"
            v-model="divisi"
            :items="division"
            required
            return-object
            disabled
            item-text="name"
          />
        </v-col>
        <v-col cols="4" class="py-0 pl-0" v-else>
          <!-- <v-autocomplete
            id="groups"
            single-line
            outlined
            dense
            :placeholder="node.type === 'bo' ? 'BO' : 'Group'"
            v-model="group"
            :items="node.type === 'bo' ? budget_owners : groups"
            required
            item-text="name"
            return-object
            @change="selectedItem()"
          /> -->
          <v-card outlined>
            <v-row class="align-items-center">
              <v-col cols="auto" class="py-0 pr-0">
                <span class="pl-1 fs-12">
                  {{ node.name || '' }}
                </span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" class="py-0 pl-0">
                <group-drawer
                  :groupType="node.type === 'bo' ? false : true"
                  v-if="node.type !== 'parent'"
                  @setGroup="setGroup"
                />
              </v-col>
            </v-row>
          </v-card>
          <v-checkbox
            v-if="node.type === 'group' || node.type === 'subgroup'"
            label="Non Brand"
            dense
            class="mt-0 fs-11"
            v-model="node.is_non_brand"
          ></v-checkbox>
          <!-- <v-text-field
            single-line
            outlined
            dense
            :placeholder="node.type === 'bo' ? 'BO' : 'Name'"
            v-model="node.name"
            required
          ></v-text-field> -->
        </v-col>
        <v-col cols="auto" class="pt-1">
          <v-row class="px-3">
            <v-btn
              color="green"
              dark
              @click="addChild()"
              v-if="node.type !== 'bo'"
            >
              <v-icon>add</v-icon>
              {{ node.type === 'parent' ? 'Group ' : 'Sub' }}
            </v-btn>
            <!-- <level-group
              v-if="node.type === 'parent'"
              :div="node"
              class="pl-2"
            /> -->
            <v-btn
              class="mx-2"
              color="primary"
              dark
              v-if="node.type !== 'parent' && node.type !== 'bo'"
              @click="addChild('bo')"
            >
              <v-icon>add</v-icon>BO
            </v-btn>
            <v-btn color="red" dark v-if="!noRemove" @click="$emit('remove')">
              <v-icon>delete_outline</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-flex>
    <!-- <input type="text" placeholder="enter name" v-model="node.name" />
    <button @click="addChild">add child</button> -->
    <!-- <button v-if="!noRemove" @click="$emit('remove')">delete</button> -->
    <ul v-if="node.children" class="dynamic">
      <li v-for="(child, index) in node.children" :key="index">
        <!-- Group {{ index + 1 }} -->
        <node
          :node="child"
          @remove="remove(index, child)"
          :budget_owners="budget_owners"
        ></node>
      </li>
    </ul>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import GroupDrawer from './groupDrawer.vue';
// import Level from './level.vue';

export default {
  name: 'node',
  components: {
    'group-drawer': GroupDrawer
    // 'level-group': Level
  },
  props: {
    node: {
      type: Object,
      required: true
    },
    noRemove: {
      type: Boolean
    },
    division: {
      type: Array
    },
    divisi: {
      type: Object
    },
    budget_owners: {
      type: Array
    }
  },
  data() {
    return {
      groups: [],
      group: {}
    };
  },
  watch: {
    divisi(val) {
      this.node.name = val.name;
      this.node.division_id = val.id;
    }
  },
  async mounted() {
    // await this.getGroup();
  },
  methods: {
    getGroup() {
      return this.$store
        .dispatch('dynamic/getGroup')
        .then(data => {
          if (data.code === 200) {
            this.groups = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    selectedItem() {
      this.node.id = this.group.id;
      this.node.name = this.group.name;
    },
    remove(index) {
      console.log(this.node);
      let text = '';
      if (this.node.children[0].type === 'group') {
        text =
          'If you delete this Group, all element in this Group will be deleted too and you can not recover this Group.';
      } else if (this.node.children[0].type === 'subgroup') {
        text =
          'If you delete this Sub Group, all element in this Sub Group will be deleted too and you can not recover this Sub Group.';
      } else if (this.node.children[0].type === 'bo') {
        text =
          'If you delete this Budget Owner, it will disappear in this Group Structure.';
      }
      Swal.fire({
        title: 'Are you sure?',
        text: text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it!'
      }).then(result => {
        if (result.value) {
          this.node.children.splice(index, 1);
        }
      });
    },
    addChild(bo) {
      if (this.node.type == 'parent') {
        let newGroup = {
          index: this.node.children.length,
          name: '',
          children: [],
          type: 'group',
          is_non_brand: false
        };
        this.node.children.splice(0, 0, newGroup);
      } else if (bo) {
        let newBo = {
          index: null,
          name: '',
          children: [],
          type: 'bo'
        };
        this.node.children.splice(0, 0, newBo);
        // let pushBo = [newBo].concat(this.node.children);
        // this.node.children = pushBo;
        // this.node.children.push({
        //   index: null,
        //   name: '',
        //   children: [],
        //   type: 'bo'
        // });
      } else if (this.node.type == 'group' || this.node.type == 'subgroup') {
        let newSubgroup = {
          index: this.node.children.length,
          name: '',
          children: [],
          type: 'subgroup'
        };
        this.node.children.splice(0, 0, newSubgroup);
      }
    },
    setGroup(item) {
      this.node.id = item.id;
      this.node.name = item.name;
    }
  }
};
</script>

<style>
/* .dynamic ul {
  counter-reset: item
}
.dynamic li {
  display: block
  }
.dynamic li:before {
  content: counters(item, ".") " "; counter-increment: item
} */
.dynamic ul,
.dynamic li {
  list-style-type: none !important;
}
</style>
